"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The MandantFile model module.
 * @module model/MandantFile
 * @version 1.0.44
 */
var MandantFile = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>MandantFile</code>.
   * Eine Datei eines Mandanten
   * @alias module:model/MandantFile
   * @param fileId {Number} ID der Datei
   * @param filename {String} Name der Datei
   * @param fileContent {String} base64 codierter Inhalt der Datei
   */
  function MandantFile(fileId, filename, fileContent) {
    _classCallCheck(this, MandantFile);
    MandantFile.initialize(this, fileId, filename, fileContent);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(MandantFile, null, [{
    key: "initialize",
    value: function initialize(obj, fileId, filename, fileContent) {
      obj['fileId'] = fileId;
      obj['filename'] = filename;
      obj['fileContent'] = fileContent;
    }

    /**
     * Constructs a <code>MandantFile</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MandantFile} obj Optional instance to populate.
     * @return {module:model/MandantFile} The populated <code>MandantFile</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new MandantFile();
        if (data.hasOwnProperty('mandantId')) {
          obj['mandantId'] = _ApiClient.default.convertToType(data['mandantId'], 'Number');
        }
        if (data.hasOwnProperty('fileId')) {
          obj['fileId'] = _ApiClient.default.convertToType(data['fileId'], 'Number');
        }
        if (data.hasOwnProperty('filename')) {
          obj['filename'] = _ApiClient.default.convertToType(data['filename'], 'String');
        }
        if (data.hasOwnProperty('fileContent')) {
          obj['fileContent'] = _ApiClient.default.convertToType(data['fileContent'], 'String');
        }
        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
        }
        if (data.hasOwnProperty('fileOrder')) {
          obj['fileOrder'] = _ApiClient.default.convertToType(data['fileOrder'], 'Number');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MandantFile</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MandantFile</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(MandantFile.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['filename'] && !(typeof data['filename'] === 'string' || data['filename'] instanceof String)) {
        throw new Error("Expected the field `filename` to be a primitive type in the JSON string but got " + data['filename']);
      }
      // ensure the json data is a string
      if (data['fileContent'] && !(typeof data['fileContent'] === 'string' || data['fileContent'] instanceof String)) {
        throw new Error("Expected the field `fileContent` to be a primitive type in the JSON string but got " + data['fileContent']);
      }
      return true;
    }
  }]);
}();
MandantFile.RequiredProperties = ["fileId", "filename", "fileContent"];

/**
 * ID des Mandanten
 * @member {Number} mandantId
 */
MandantFile.prototype['mandantId'] = undefined;

/**
 * ID der Datei
 * @member {Number} fileId
 */
MandantFile.prototype['fileId'] = undefined;

/**
 * Name der Datei
 * @member {String} filename
 */
MandantFile.prototype['filename'] = undefined;

/**
 * base64 codierter Inhalt der Datei
 * @member {String} fileContent
 */
MandantFile.prototype['fileContent'] = undefined;

/**
 * interne ID der Datei
 * @member {Number} id
 */
MandantFile.prototype['id'] = undefined;

/**
 * Position in der Reihenfolge der Dateien
 * @member {Number} fileOrder
 */
MandantFile.prototype['fileOrder'] = undefined;
var _default = exports.default = MandantFile;